import { IPagedDataTable } from '../shared-module/common/interfaces/IPagedDataTable.interface';
import { ILookup } from '../shared-module/common/interfaces/ILookup.interface';

export class ExampleTypeRow {
  public id: number;
  public name: string;
  public weight: string;
  public symbol: string;
}


export class ExampleDataTable implements IPagedDataTable<ExampleTypeRow>
{
  pagedRecords: ExampleTypeRow[] = new Array;
  totalNumberOfRecords: number;

  constructor() {
    this.pagedRecords.push({ id: 1, name: "Oxygen", weight: "15.9994", symbol: "O" });
    this.pagedRecords.push({ id: 2, name: "Nitrogen", weight: "14.0067", symbol: "N" });
    this.pagedRecords.push({ id: 3, name: "Neon", weight: "20.1797", symbol: "Ne" });
    this.pagedRecords.push({ id: 3, name: "Lithium", weight: "6.941", symbol: "Li" });
    this.pagedRecords.push({ id: 3, name: "Hydrogen", weight: "1.0079", symbol: "H" });
    this.totalNumberOfRecords = this.pagedRecords.length;
  }
}

export class ExampleTranslationField {
  public id: number;
  public name: string;
  public label: string;
  public mlValues: Array<ILookup<number, string>> = new Array<ILookup<number, string>>();

  public lookup: ILookup<number, string> = new ILookup<number, string>();

  constructor() {
    this.id = 1;
    this.name = "Custom Field";
    this.label = "Custom Field Label";

    this.lookup.id = 4;
    this.lookup.text = "translation";

    this.mlValues.push(this.lookup);
  }
}

export class Link {
  name: string;
  url: string;
}

export class CodeItem {
  name: string;
  htmlCode: string;
  tsCode: string;
  links?: Array<Link>;
}
export const PlaybookCode: Array<CodeItem> = [
  {
    name: "CpqDialog",
    htmlCode: `
    <button type="button" mat-button  class="mt-5 btn btn-primary" (click)="simulateCpqAttributesDataTableDialogComponent()">Open product attributes</button>
    `, tsCode: `
    public simulateCpqAttributesDataTableDialogComponent() {
        this.dialog.open(CpqAttributesDataTableDialogComponent, { data: { productId: 1 } });
      }
    `, links: [{ name: "[add products]", url: "products/add-edit-product/0" }
    ]
  },
  {
    name: "CpqBreadcrumb",
    htmlCode: `
    <cpq-breadcrumb [breadcrumbs]="[{ label:{ key:'products'}, url:'products'},{ label:{ key:'add-edit-products'}, url:'products/add-edit-product/444'}]"></cpq-breadcrumb>
    `, tsCode: `
    `,
    links: [
      { name: "[add user]", url: "users/add-edit-user/0" },
    ]
  },
  {
    name: "CpqButtonMenu",
    htmlCode: `
    <cpq-button-menu [items]="menuButtons[0].actions" btnStyleClass = "btn-primary margin-right-20" [buttonText]="menuButtons[0].key"></cpq-button-menu>
    <cpq-button-menu [items]="menuButtons[1].actions" btnStyleClass = "btn-secondary margin-right-20" [buttonText]="menuButtons[1].key"></cpq-button-menu>
    <cpq-button-menu [items]="menuButtons[2].actions" btnStyleClass = "btn-secondary margin-right-20" [buttonText]="menuButtons[2].key"></cpq-button-menu>
    `,
    tsCode: `
        public menuButtons: Array<ActionButton>; // fake buttons
        ngOnInit() {
            this.initCpqButtonMenu();
        }
        initCpqButtonMenu() {
          this.menuButtons = [
            {
              key: 'Primary button',
              url: '/products',
              type: ActionButtonType.Primary
            },
            {
              key: 'Secondary button',
              url: '/products',
              type: ActionButtonType.Secondary
            },
            {
              key: 'Menu button',
              url: '/products',
              type: ActionButtonType.MenuButton
            }
          ];
        }
    `,
    links: [{ name: "[add products]", url: "products/add-edit-product/0" }]
  },
  {
    name: "CpqMultiListBoxDialog",
    htmlCode: `
    <button type="button" mat-button  class="mt-5 btn btn-primary" (click)="simulateCpqMultiListBoxDialog()">Open category tree</button>
    `,
    tsCode: `
           public simulateCpqMultiListBoxDialog() {
            const data: CpqMultiListBoxDialogData = {
              selectedItems: [1, 2], 
              isMultiSelect: false,
              service: this.playbookMultiListBoxDialogService
            };
            this.dialog.open(CpqMultiListBoxDialogComponent, {
              data: data,
              minWidth: '450px',
              maxWidth: '100%'
            });
          }
        `
    ,
    links: [{ name: "[add products]", url: "products/add-edit-product/0" }
    ]

  },
  {
    name: "CpqDatatable", htmlCode: `
    <cpq-datatable #dataTable [service]='service' [columns]="columns"  [filter] = "filter" >
        </cpq-datatable>
    `,
    tsCode: `

        @ViewChild('dataTable') dataTable: CpqDatatableComponent;
        public datatableColumns = new Array<IColumn>();
        public datatableFilter: DataTableFilter;
        ngOnInit() {
            this.initCpqDatatable();
        }

        initCpqDatatable() {
          this.datatableColumns = [
            {
              prop: 'name',
              name: 'Name',
              sortable: true,
              visible: true
            },
            {
              prop: 'weight',
              name: 'Weight',
              sortable: true,
              visible: true
            }
            ,
            {
              prop: 'symbol',
              name: 'Symbol',
              sortable: true,
              visible: true
            }
          ];
        }
    `,
    links: [{ name: "[users]", url: "users" },
    { name: "[user types]", url: "users/user-types" }
    ]
  },
  {
    name: "CpqDatepicker",
    htmlCode: `
    <cpq-date-picker #Date="ngModel" [label]="{key: 'Date', placeholder: 'Please pick date'}"
            [control]="Date" [(ngModel)]="exampleDate" name="Date"></cpq-date-picker>
    `,
    tsCode: `
        public exampleDate: Date;
        ngOnInit() {
            this.initCpqDatepicker();
        }
        initCpqDatepicker() {
            this.exampleDate = new Date(2018, 1);
          }
    `,
    links: [
      { name: "[add products]", url: "products/add-edit-product/0" }
    ]
  },
  {
    name: "CpqInfo",
    htmlCode: `
    <cpq-info class="cpq-info-icon" [message]="{key: 'Info message'}"></cpq-info>
    `,
    tsCode: ``,
    links: [
      { name: "[companies]", url: "users/companies/add-edit-company/0" },
      { name: "[add products]", url: "products/add-edit-product/0" }
    ]
  },
  {
    name: "CpqInput",
    htmlCode: `
    <cpq-input #exName="ngModel" [label]="{key: 'Example name'}" name="exName" [(ngModel)]='inputModel.exName' ></cpq-input>
    `,
    tsCode: `
    public inputModel = "";
    `,
    links: [

      { name: "[add user]", url: "users/add-edit-user/0" },
      { name: "[guest user]", url: "users/guest-user" }]
  },
  {
    name: "CpqInputError",
    htmlCode: `
    <cpq-input-error cpqNumber [cpqNumberOptions]="{allowDecimal: true, minValue: 0, maxValue: 100, includeMinValue: true, includeMaxValue: true}" [label]="{key:'Number'}" #name="ngModel" [control]='name'
          name="name" maxlength="50" [(ngModel)]="inputModel" [cpqRequired]='true'></cpq-input-error>
    `,
    tsCode: `
    public inputModel = "";
    `,
    links: [
      { name: "[add user]", url: "users/add-edit-user/0" },
      { name: "[guest user]", url: "users/guest-user" },
      { name: "[security dkim]", url: "security/dkim" }
    ]
  },
  {
    name: "CpqListBox",
    htmlCode: `
    <cpq-list-box name="listboxitems" [(items)]="listBoxItems" [(selectedItems)]="selectedListBoxItems"></cpq-list-box>
    `, tsCode: `
    public listBoxItems: Array<ListBoxItem>;
    public selectedListBoxItems: number[];

    ngOnInit() {
        this.initCpqListBox();
    }
    initCpqListBox() 
    {
      this.listBoxItems = new Array;
      this.selectedListBoxItems = new Array;
      this.selectedListBoxItems.push(1);
      this.selectedListBoxItems.push(2);
      this.listBoxItems.push(new ListBoxItem(1, "Orange"));
      this.listBoxItems.push(new ListBoxItem(2, "Banana"));
      this.listBoxItems.push(new ListBoxItem(3, "Apple"));
      this.listBoxItems.push(new ListBoxItem(4, "Blackberry"));
    }
    `,
    links: [{ name: "[guest user]", url: "users/guest-user" }
    ]
  },
  {
    name: "CpqMultiCheckboxWithSelection",
    htmlCode: `
    <cpq-multi-checkbox-with-selection  [items]="multiListBoxItems" [selectedItems]="selectedMultiListBoxItems" [labelAvailable]="{key: 'Fields', placeholder:'Search'}"></cpq-multi-checkbox-with-selection>
    `, tsCode: `
    public multiListBoxItems: Array<MultiListBoxItem>;
    public childrenMultiListBoxItemsFirst: Array<MultiListBoxItem>;
    public childrenMultiListBoxItemsSecond: Array<MultiListBoxItem>;
    public childrenMultiListBoxItemsThird: Array<MultiListBoxItem>;
    public childrenMultiListBoxItemsFourth: Array<MultiListBoxItem>;
    public selectedMultiListBoxItems = new Array<MultiListBoxItem>();
    ngOnInit() {
        this.initCpqMultiListBox();
    }
    initCpqMultiListBox() {
      this.childrenMultiListBoxItemsFirst= new Array<MultiListBoxItem>();
      this.childrenMultiListBoxItemsSecond = new Array<MultiListBoxItem>();
      this.childrenMultiListBoxItemsThird = new Array<MultiListBoxItem>();
      this.childrenMultiListBoxItemsFourth = new Array<MultiListBoxItem>();
  
      this.childrenMultiListBoxItemsFirst.push({ id: 1, name: "White cotton", children: new Array<MultiListBoxItem>(), parentId: 1 })
      this.childrenMultiListBoxItemsFirst.push({ id: 2, name: "Couloured, cotton, silk & synthetic", children: new Array<MultiListBoxItem>(), parentId: 0 })
  
      this.childrenMultiListBoxItemsSecond.push({ id: 1, name: "Casuals", children: new Array<MultiListBoxItem>(), parentId: 2 })
      this.childrenMultiListBoxItemsSecond.push({ id: 2, name: "Fancy", children: new Array<MultiListBoxItem>(), parentId: 2 })
      this.childrenMultiListBoxItemsSecond.push({ id: 3, name: "Evening", children: new Array<MultiListBoxItem>(), parentId: 2 })
      this.childrenMultiListBoxItemsSecond.push({ id: 4, name: "High fashion", children: new Array<MultiListBoxItem>(), parentId: 2 })
  
  
      this.childrenMultiListBoxItemsThird.push({ id: 1, name: "Jackets", children: new Array<MultiListBoxItem>(), parentId: 3 })
      this.childrenMultiListBoxItemsThird.push({ id: 2, name: "Jeans or skirts", children: new Array<MultiListBoxItem>(), parentId: 3 })
      this.childrenMultiListBoxItemsThird.push({ id: 3, name: "Bleached or stonewashed", children: new Array<MultiListBoxItem>(), parentId: 3 })
  
  
      this.childrenMultiListBoxItemsFourth.push({ id: 1, name: "Plain", children: new Array<MultiListBoxItem>(), parentId: 4 })
      this.childrenMultiListBoxItemsFourth.push({ id: 2, name: "Wool or silk", children: new Array<MultiListBoxItem>(), parentId: 4 })
      this.childrenMultiListBoxItemsFourth.push({ id: 3, name: "Casual cotton blend", children: new Array<MultiListBoxItem>(), parentId: 4 })
  
  
      this.multiListBoxItems = new Array<MultiListBoxItem>();
      this.multiListBoxItems.push({ id: 1, name: "Blouses, (Dress and Sports)", isVisible: false, children: this.childrenMultiListBoxItemsFirst, parentId: 0 });
      this.multiListBoxItems.push({ id: 2, name: "Dresses", isVisible: false, children: this.childrenMultiListBoxItemsSecond, parentId: 0 });
      this.multiListBoxItems.push({ id: 3, name: "Denim", isVisible: false, children: this.childrenMultiListBoxItemsThird, parentId: 0 });
      this.multiListBoxItems.push({ id: 4, name: "Shirts", isVisible: false, children: this.childrenMultiListBoxItemsFourth, parentId: 0 });
    }
    `,
    links: [
    ]
  },
  {
    name: "CpqSetupNotFound",
    htmlCode: `
    <cpq-setup-not-found></cpq-setup-not-found>
    `, tsCode: `
    `,
    links: [
    ]
  },
  {
    name: "CpqTextarea", htmlCode: `
    <cpq-textarea #descriptiontext="ngModel" [label]="{key: 'Example textarea'}" name="'descriptiontext'"
                    [control]="descriptiontext" [(ngModel)]='textAreaValue' maxlength="1000"></cpq-textarea>
    `, tsCode: `
    public textAreaValue: string;
    ngOnInit() {
      this.initCpqTextArea();
    }
    initCpqTextArea() {
        this.textAreaValue = "Example of text of textarea";
      }
    `,
    links: [
      { name: "[add user permissions]", url: "users/permissions/add-edit-permission-group/0" }
    ]
  },
  {
    name: "CpqRanking", htmlCode: `
    <cpq-ranking [nodes]="rankings" >
        </cpq-ranking>
    `, tsCode: `
    public rankings = new Array<RankingNode>();
    ngOnInit() {
        this.initCpqRankings();
    }

    initCpqRankings() {
      this.rankings.push({ id: 1, name: "158", position: 1 });
      this.rankings.push({ id: 2, name: "221", position: 2 });
      this.rankings.push({ id: 3, name: "33", position: 3 });
    }
    `,
    links: [{ name: "[add user custom fields]", url: "users/user-custom-fields/add-edit-user-custom-fields/0" }
    ]
  },
  {
    name: "CpqToggle", htmlCode: `
    <cpq-toggle [name]="'toggle'" [(ngModel)]="showToggle" [label]="{key: 'Toggle example'}">
            </cpq-toggle>`
    , tsCode: `

        public showToggle: boolean;
    `,
    links: [
      { name: "[security dkim]", url: "security/dkim" },
      { name: "[security data-deletion]", url: "security/data-deletion" }
    ]
  },
  {
    name: "CpqRadioButton", htmlCode: `
    <cpq-radio-button [name]="'radioButton'" [(ngModel)]="radioButtonModel" [buttons]="radioButtonValues" [label]="{key: '', value: 'Radio Button'}" [required]="true">
                </cpq-radio-button>`
    , tsCode: `

        public radioButtonModel: string;
        public radioButtonValues = new Array<RadioButtonValue>();

        initCpqRadioButton() {
          this.radioButtonModel = "radioButton";
          this.radioButtonValues = [
            { label: {key: '', value: 'Email'}, value: 'email' },
            { label: {key: '', value: 'Phone'}, value: 'phone'  },
            { label: {key: '', value: 'Mail'}, value: 'mail'  }
          ];
        }
    `,
    links: [
      { name: "[change set]", url: "audit-trail/change-set" },
      { name: "[guided selling]", url: "products/guided-selling" },
      { name: "[brim provider]", url: "providers/brim-provider" },
      { name: "[add certificate]", url: "security/certificate-management" },
      { name: "[add edit dkim]", url: "security/dkim" },
      { name: "[view export pii]", url: "security/view-export-pii" }
    ]
  },
  
  {
    name: "gdfg", htmlCode: `
        <cpq-multi-checkbox-with-selection [items]="multiListBoxItems" [selectedItems]="selectedMultiListBoxItems"
            [labelAvailable]="{key: 'Fields', placeholder:'Search'}">
        </cpq-multi-checkbox-with-selection>
        `
    , tsCode: `
        public multiListBoxItems: Array<MultiListBoxItem>;
        public childrenMultiListBoxItems: Array<MultiListBoxItem>;
        public selectedMultiListBoxItems = new Array<MultiListBoxItem>();

        ngOnInit() {
            this.initCpqMultiListBox();
        }
        initCpqMultiListBox()
        {
          this.childrenMultiListBoxItems = new Array<MultiListBoxItem>();
          this.childrenMultiListBoxItems.push({id:0,name:"First child",children: new Array<MultiListBoxItem>(), parentId:0})
          this.childrenMultiListBoxItems.push({id:1,name:"Second child",children: new Array<MultiListBoxItem>(), parentId:0})
          this.childrenMultiListBoxItems.push({id:2,name:"Third child", children: new Array<MultiListBoxItem>(), parentId:0})
          this.childrenMultiListBoxItems.push({id:3,name:"Fourth child",children: new Array<MultiListBoxItem>(), parentId:0})
      
          this.multiListBoxItems =  new Array<MultiListBoxItem>();
          this.multiListBoxItems.push({id:1,name:"First name", isVisible:false,children: this.childrenMultiListBoxItems, parentId:0});
          this.multiListBoxItems.push({id:2,name:"Second name", isVisible:false,children: this.childrenMultiListBoxItems, parentId:0});
        }
    `,
    links: [
    ]
  }

  ,

  {
    name: "CpqSelect", htmlCode: `
        <cpq-select name="displayType" [(ngModel)]="cpqSelectType" [items]="cpqSelectOptions" [label]="{key: 'Select'}">
        </cpq-select>
        `
    , tsCode: `
        public cpqSelectOptions: Array<any>;
        public cpqSelectType: number;
        ngOnInit() {
            this.initCpqSelect();
        }
        initCpqSelect() {
            this.cpqSelectOptions = [
              { id: 0, text: '' },
              { id: 1, text: 'First Option' },
              { id: 2, text: 'Second Option' }
            ];
          }
    `,
    links: [
      { name: "[add user]", url: "users/add-edit-user/0" },
      { name: "[add user type]", url: "users/user-types/add-edit-user-type/0" },
      { name: "[add user custom fields]", url: "users/user-custom-fields/add-edit-user-custom-fields/0" },
    ]
  }
  ,
  {
    name: "CpqFormulaBuilder", htmlCode: `
        <cpq-textarea #condition="ngModel" [label]="{key: ''}" name="condition" [config]="cpqFormulaBuilderConfig"
        [control]="condition" [(ngModel)]='cpqFormulaBuilderCondition' maxlength="3000"></cpq-textarea>
        `
    , tsCode: `
        public cpqFormulaBuilderCondition: string;
        public cpqFormulaBuilderConfig: FormulaBuilderConfig;

        ngOnInit() {
          this.initCpqFormulaBuilder();
      }
        initCpqFormulaBuilder() {
            this.cpqFormulaBuilderConfig = new FormulaBuilderConfig(FormulaBuilderType.Cart, this.cpqFormulaBuilderCondition, false, true);
          }
    `,
    links: [{ name: "[add products]", url: "products/add-edit-product/0" }
    ]
  }
  ,
  {
    name: "CpqMultiListBoxMultiLevel", htmlCode: `
        <cpq-multi-list-box  [isMultiSelect]='true' [labelAvailable]="{placeholder: 'Search'}" [items]='multiListBoxItems'></cpq-multi-list-box>
        `
    , tsCode: `
        public multiListBoxItems: Array<MultiListBoxItem>;
        public childrenMultiListBoxItemsFirst: Array<MultiListBoxItem>;
        public childrenMultiListBoxItemsSecond: Array<MultiListBoxItem>;
        public childrenMultiListBoxItemsThird: Array<MultiListBoxItem>;
        public childrenMultiListBoxItemsFourth: Array<MultiListBoxItem>;
        public selectedMultiListBoxItems = new Array<MultiListBoxItem>();

        ngOnInit() {
            this.initCpqMultiListBox();
        }

        initCpqMultiListBox() {
          this.childrenMultiListBoxItemsFirst= new Array<MultiListBoxItem>();
          this.childrenMultiListBoxItemsSecond = new Array<MultiListBoxItem>();
          this.childrenMultiListBoxItemsThird = new Array<MultiListBoxItem>();
          this.childrenMultiListBoxItemsFourth = new Array<MultiListBoxItem>();
      
          this.childrenMultiListBoxItemsFirst.push({ id: 1, name: "White cotton", children: new Array<MultiListBoxItem>(), parentId: 1 })
          this.childrenMultiListBoxItemsFirst.push({ id: 2, name: "Couloured, cotton, silk & synthetic", children: new Array<MultiListBoxItem>(), parentId: 0 })
      
          this.childrenMultiListBoxItemsSecond.push({ id: 1, name: "Casuals", children: new Array<MultiListBoxItem>(), parentId: 2 })
          this.childrenMultiListBoxItemsSecond.push({ id: 2, name: "Fancy", children: new Array<MultiListBoxItem>(), parentId: 2 })
          this.childrenMultiListBoxItemsSecond.push({ id: 3, name: "Evening", children: new Array<MultiListBoxItem>(), parentId: 2 })
          this.childrenMultiListBoxItemsSecond.push({ id: 4, name: "High fashion", children: new Array<MultiListBoxItem>(), parentId: 2 })
      
      
          this.childrenMultiListBoxItemsThird.push({ id: 1, name: "Jackets", children: new Array<MultiListBoxItem>(), parentId: 3 })
          this.childrenMultiListBoxItemsThird.push({ id: 2, name: "Jeans or skirts", children: new Array<MultiListBoxItem>(), parentId: 3 })
          this.childrenMultiListBoxItemsThird.push({ id: 3, name: "Bleached or stonewashed", children: new Array<MultiListBoxItem>(), parentId: 3 })
      
      
          this.childrenMultiListBoxItemsFourth.push({ id: 1, name: "Plain", children: new Array<MultiListBoxItem>(), parentId: 4 })
          this.childrenMultiListBoxItemsFourth.push({ id: 2, name: "Wool or silk", children: new Array<MultiListBoxItem>(), parentId: 4 })
          this.childrenMultiListBoxItemsFourth.push({ id: 3, name: "Casual cotton blend", children: new Array<MultiListBoxItem>(), parentId: 4 })
      
      
          this.multiListBoxItems = new Array<MultiListBoxItem>();
          this.multiListBoxItems.push({ id: 1, name: "Blouses, (Dress and Sports)", isVisible: false, children: this.childrenMultiListBoxItemsFirst, parentId: 0 });
          this.multiListBoxItems.push({ id: 2, name: "Dresses", isVisible: false, children: this.childrenMultiListBoxItemsSecond, parentId: 0 });
          this.multiListBoxItems.push({ id: 3, name: "Denim", isVisible: false, children: this.childrenMultiListBoxItemsThird, parentId: 0 });
          this.multiListBoxItems.push({ id: 4, name: "Shirts", isVisible: false, children: this.childrenMultiListBoxItemsFourth, parentId: 0 });
        }
    `,
    links: [{ name: "[add products]", url: "products/add-edit-product/0" }]
  },
  {
    name: "CpqMultiListBoxSingleLevel", htmlCode: `
        <cpq-multi-list-box  [isMultiSelect]='true' [labelAvailable]="{placeholder: 'Search'}" [isMultilevelList]='false' [items]='multiListBoxItems'></cpq-multi-list-box>
        `
    , tsCode: `
        public multiListBoxItems: Array<MultiListBoxItem>;
        public childrenMultiListBoxItemsFirst: Array<MultiListBoxItem>;
        public childrenMultiListBoxItemsSecond: Array<MultiListBoxItem>;
        public childrenMultiListBoxItemsThird: Array<MultiListBoxItem>;
        public childrenMultiListBoxItemsFourth: Array<MultiListBoxItem>;
        public selectedMultiListBoxItems = new Array<MultiListBoxItem>();

        ngOnInit() {
            this.initCpqMultiListBox();
        }

        initCpqMultiListBox() {
          this.childrenMultiListBoxItemsFirst= new Array<MultiListBoxItem>();
          this.childrenMultiListBoxItemsSecond = new Array<MultiListBoxItem>();
          this.childrenMultiListBoxItemsThird = new Array<MultiListBoxItem>();
          this.childrenMultiListBoxItemsFourth = new Array<MultiListBoxItem>();
      
          this.childrenMultiListBoxItemsFirst.push({ id: 1, name: "White cotton", children: new Array<MultiListBoxItem>(), parentId: 1 })
          this.childrenMultiListBoxItemsFirst.push({ id: 2, name: "Couloured, cotton, silk & synthetic", children: new Array<MultiListBoxItem>(), parentId: 0 })
      
          this.childrenMultiListBoxItemsSecond.push({ id: 1, name: "Casuals", children: new Array<MultiListBoxItem>(), parentId: 2 })
          this.childrenMultiListBoxItemsSecond.push({ id: 2, name: "Fancy", children: new Array<MultiListBoxItem>(), parentId: 2 })
          this.childrenMultiListBoxItemsSecond.push({ id: 3, name: "Evening", children: new Array<MultiListBoxItem>(), parentId: 2 })
          this.childrenMultiListBoxItemsSecond.push({ id: 4, name: "High fashion", children: new Array<MultiListBoxItem>(), parentId: 2 })
      
      
          this.childrenMultiListBoxItemsThird.push({ id: 1, name: "Jackets", children: new Array<MultiListBoxItem>(), parentId: 3 })
          this.childrenMultiListBoxItemsThird.push({ id: 2, name: "Jeans or skirts", children: new Array<MultiListBoxItem>(), parentId: 3 })
          this.childrenMultiListBoxItemsThird.push({ id: 3, name: "Bleached or stonewashed", children: new Array<MultiListBoxItem>(), parentId: 3 })
      
      
          this.childrenMultiListBoxItemsFourth.push({ id: 1, name: "Plain", children: new Array<MultiListBoxItem>(), parentId: 4 })
          this.childrenMultiListBoxItemsFourth.push({ id: 2, name: "Wool or silk", children: new Array<MultiListBoxItem>(), parentId: 4 })
          this.childrenMultiListBoxItemsFourth.push({ id: 3, name: "Casual cotton blend", children: new Array<MultiListBoxItem>(), parentId: 4 })
      
      
          this.multiListBoxItems = new Array<MultiListBoxItem>();
          this.multiListBoxItems.push({ id: 1, name: "Blouses, (Dress and Sports)", isVisible: false, children: this.childrenMultiListBoxItemsFirst, parentId: 0 });
          this.multiListBoxItems.push({ id: 2, name: "Dresses", isVisible: false, children: this.childrenMultiListBoxItemsSecond, parentId: 0 });
          this.multiListBoxItems.push({ id: 3, name: "Denim", isVisible: false, children: this.childrenMultiListBoxItemsThird, parentId: 0 });
          this.multiListBoxItems.push({ id: 4, name: "Shirts", isVisible: false, children: this.childrenMultiListBoxItemsFourth, parentId: 0 });
        }
    `,
    links: [{ name: "[add products]", url: "products/add-edit-product/0" }]
  }
  ,
  {
    name: "CpqNestedList", htmlCode: `
        <cpq-nested-list [list]="cpqNestedListItems" [selected]='cpqNestedListSelected' [firstLevel]="false"></cpq-nested-list>
        `
    , tsCode: `

        public cpqNestedListItems: Array<ListItem>;
        public cpqNestedListSelected: SelectedItem;

        ngOnInit() {
            this.initCpqNestedList();
        }
        
        initCpqNestedList()
        {
          this.cpqNestedListItems =  new Array<ListItem>();
          this.cpqNestedListItems.push({name:"First Item", id:1})
          this.cpqNestedListItems.push({name:"Second Item", id:2})
          this.cpqNestedListItems.push({name:"Third Item", id:3})
          this.cpqNestedListSelected = {name:"First Item", selectedId:1}
         
        }
    `,
    links: [{ name: "[guest user]", url: "users/guest-user" }
    ]
  }
  ,
  {
    name: "CpqSystemId",
    htmlCode: `
        <cpq-setup-cpq-system-id #systemId='ngModel' [control]='systemId' [modelName]="'modelName'" [(ngModel)]="systemid" [isNew]='!systemid'
        name="'systemId'" [cpqRequired]='true' maxlength="150" [url]="'products/productType/systemId'"></cpq-setup-cpq-system-id>            
        `
    , tsCode: `
     public systemid:number;
    `,
    links: [{ name: "[add user]", url: "users/add-edit-user/0" },
    { name: "[add edit user permission group]", url: "users/permissions/add-edit-permission-group/0" },
    { name: "[add edit companies]", url: "users/companies/add-edit-company/0" }
    ]
  },

  {
    name: "CpqFileSelectWithFileSystem",
    htmlCode: `
      <cpq-file-select [type]="1" [label]="{key: ''}" name="imageOn"  [allowedExtensions]="cpqFileSelectExtensions" accept="image/*"
      [apiUrl]="'files/attributeimage'"></cpq-file-select>
      `
    , tsCode: `
    public cpqFileSelectExtensions: Array<string>;

    ngOnInit() {
      this.initCpqFileSelect();
    }
    initCpqFileSelect()
  {
    this.cpqFileSelectExtensions= new Array<string>();
    this.cpqFileSelectExtensions.push(".png");
    this.cpqFileSelectExtensions.push(".jpg");
  }

  `,
    links: [
      { name: "[add edit companies]", url: "users/companies/add-edit-company/0" }
    ]
  },
  {
    name: "CpqPermissionGroupSelection",
    htmlCode: `
    <cpq-permission-groups-selection  [skipPermissions]='[PermissionType.Users]' [selectedPermissionGroups]="selectedPermissions"
[availablePermissionGroups]='availablePermissionGroups' ></cpq-permission-groups-selection>
    `
    , tsCode: `
    public availablePermissionGroups: PermissionGroupCollection;
    public selectedPermissions: Array<MultiListBoxItem>;
    public PermissionType = PermissionType;

    ngOnInit() {
      this.initCpqPermissionGroupSelection();
    }

    initCpqPermissionGroupSelection() {
      this.availablePermissionGroups = new PermissionGroupCollection();
      this.availablePermissionGroups.manualPermissions =
        {
          id: 0,
          name: "Custom Permission Groups",
          isVisible: true,
          isCollapsed: true,
          parentId: 0,
          children: [
            {
              id: 53,
              name: "Admin",
              isVisible: true,
              parentId: 0
            },
            {
              id: 54,
              name: "User",
              isVisible: true,
              parentId: 0
            }
          
          ]
        };
      this.availablePermissionGroups.companyPermissions =
        {
          id: 2,
          name: "Companies",
          isVisible: true,
          isCollapsed: true,
          parentId: 0,
          children: [
            {
              id: 97,
              name: "WebCom Inc",
              isVisible: true,
              parentId: 2
            }]
        }
      this.availablePermissionGroups.marketPermissions =
        {
          id: 3,
          name: "Markets",
          isVisible: true,
          isCollapsed: true,
          parentId: 0,
          children: [
            {
              "id": 25,
              "name": "Canada in C$",
              "isVisible": true,
              "parentId": 3
            }]
        };
      this.availablePermissionGroups.multiBrandingPermissions =
        {
          id: 4,
          name: "Brands",
          isVisible: true,
          isCollapsed: true,
          parentId: 0,
          children: [
            {
              id: 68,
              name: "Nordson",
              isVisible: true,
              parentId: 4
            }]
        }
      this.availablePermissionGroups.userTypePermissions = {
        id: 1,
        name: "User Types",
        isVisible: true,
        isCollapsed: true,
        parentId: 0,
        children: [
          {
            id: 56,
            name: "Customer",
            isVisible: true,
            parentId: 1
          },
          {
            id: 57,
            name: "Sales",
            isVisible: true,
            parentId: 1
          }]
      }
  
  
  
      this.availablePermissionGroups.users =
        {
          id: 5,
          name: "Users",
          isVisible: true,
          isCollapsed: true,
          parentId: 0,
          children: [
  
          ]
        }
  
      this.selectedPermissions = new Array<MultiListBoxItem>();
  
    }
`,
    links: [
      { name: "[add edit user permission group]", url: "users/permissions/add-edit-permission-group/0" }
    ]
  },
  {
    name: "CpqListBoxWithSelection",
    htmlCode: `
    <cpq-list-box-with-selection [labelAvailable]="{key: 'Available List Items'}" [available]='listBoxItems'
                [labelSelected]="{key: 'Selected List Items'}"  [selected]='selectedItems' 
                [emptySelectedInfoMessage]="{key: 'Select items from the lists on the left.'}">
    </cpq-list-box-with-selection>
      `
    , tsCode: `
    public listBoxItems: Array<ListBoxItem>;
    public selectedItems: Array<ListBoxItem>;

    ngOnInit() {
      this.initCpqListBoxWithSelection();
    }

    initCpqListBoxWithSelection() {
      this.listBoxItems = new Array<ListBoxItem>();
      this.listBoxItems.push(new ListBoxItem(1, "Orange"));
      this.listBoxItems.push(new ListBoxItem(2, "Banana"));
      this.listBoxItems.push(new ListBoxItem(3, "Apple"));
      this.listBoxItems.push(new ListBoxItem(4, "Blackberry"));
      
      this.selectedItems = new Array<ListBoxItem>();
    }
  `,
    links: [
      { name: "[guest user: default user settings]", url: "users/guest-user" }
    ]
  },
  {
    name: "CpqMultiListBoxWithSelection",
    htmlCode: `
    <cpq-multi-list-box-with-selection [isCpqPermissions]='true'
                        [labelAvailable]="{key: 'Available List Items'}" [labelSelected]="{key: 'Selected List Items'}"
                        [available]='available' [selected]='selected'>
                    </cpq-multi-list-box-with-selection>
      `
    , tsCode: `
    public available: Array<MultiListBoxItem>;
    public selected:Array<MultiListBoxItem>;

    ngOnInit() {
      this.initMultiSelectBox();
    }
    initMultiSelectBox()
   {
    this.selected = new Array<MultiListBoxItem>();
    this.available =  new Array<MultiListBoxItem>();
    this.available.push({ id: 1, name: "Custom Permission Groups", children: [
      {
        id: 53,
        name: "Admin",
        isVisible: true,
        parentId: 0
      },
      {
        id: 54,
        name: "User",
        isVisible: true,
        parentId: 0
      }
    
    ], parentId: 0 })
    this.available.push({ id: 2, name: "Companies", children: [
      {
        id: 53,
        name: "Webcom Inc",
        isVisible: true,
        parentId: 0
      },
      {
        id: 54,
        name: "SAP",
        isVisible: true,
        parentId: 0
      }
    
    ], parentId: 0 })
  }

  `,
    links: [
      { name: "[add edit user permission group]", url: "users/permissions/add-edit-permission-group/0" }
    ]
  },
  {
    name: "CpqTranslations",
    htmlCode: `
        <cpq-translations [breadcrumbs]="" [headerLabel]="{key: 'Field'}" [translationFieldLabel]="{key: 'Label'}" [translationField]="exampleTranslationField" [returnUrl]="translationResturnUrl" [translationFieldService]="service" [showSaveButton]="showSaveButton">
        </cpq-translations>
      `
    , tsCode: `
        public exampleTranslationField = new ExampleTranslationField();
      `
    ,
    links: [
      { name: "[user custom fields translate this item]", url: "users/user-custom-fields/" },
      { name: "[partner functions translate this item]", url: "business-partners/partner-functions/" }
    ]
  },
  {
    name: "CpqTabs",
    htmlCode: `
        <cpq-tabs [tabs]="tabs"></cpq-tabs>
        <ng-template #tabContent1>
            <h5>Tab content 1</h5>
            <div>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ex nulla dolorum neque iusto cupiditate consectetur. Eius tempora quisquam quas laborum!</div>
        </ng-template>
        <ng-template #tabContent2>
            <h5>Tab content 2</h5>
          <div>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Hic magni explicabo eveniet voluptates fugit odio esse, modi numquam accusamus temporibus.</div>
        </ng-template>
      `
    , tsCode: `
        public tabs: Array<NavTab>
        ngOnInit() {
          this.initTabs();
        }
        initTabs() {
          this.tabs = [
            {
              tabIndex: 1,
              name: 'First tab',
              active: true,
              tabTemplate: this.tabContent1
            },
            {
              tabIndex: 2,
              name: 'Second tab',
              tabTemplate: this.tabContent2
            }
          ];
        }
      `
    ,
    links: [
      { name: "[document generation templates]", url: "quote/document-generation/" },
      { name: "[edit document generation templates]", url: "quote/document-generation/" },
    ]
  }
]
